<template>
  <div>
    <el-dialog :title="jianPeiSettingData.title" :visible.sync="jianPeiSettingData.show" width="800px" center>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    jianPeiSettingData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>